const FIELD_SEPARATOR = ';'
const KVP_SEPARATOR = ':'
const VALUES_SEPARATOR = ','

/**
 * Serializes one or more fields into a single string to be passed as a URL filter
 *
 * @example
 * input: {
 *   field_one: {
 *     values: [ 'value a', 'value b' ]
 *   },
 *   field_two: {
 *     values: [ 'value c' ]
 *   },
 *   field_three: {
 *     operation: 'notContains',
 *     values: [ 'value d' ]
 *   },
 * }
 * output: field_one:value+a,value+b;field_two:value+c;field_three:notContains:value+d
 *
 * @param {Object} filterObj An o
 * @returns {string} The serialized filter
 */
export function serializeFilter (filterObj) {
  return Object.entries(filterObj)
    .map(([field, { operation, values }]) => {
      // join values using VALUES_SEPARATOR
      const valuesPart = values.map(encodeURIComponent).join(VALUES_SEPARATOR)

      // if operation exists, include it
      return operation
        ? `${field}${KVP_SEPARATOR}${operation}${KVP_SEPARATOR}${valuesPart}`
        : `${field}${KVP_SEPARATOR}${valuesPart}`
    })
    .join(FIELD_SEPARATOR)
}

/**
 * Deserializes a URL filter string into an object representation
 *
 * @param {string} filterStr The serialized filter string
 * @returns {Object} The deserialized filter object
 */
export function deserializeFilter (filterStr) {
  return filterStr.split(FIELD_SEPARATOR).reduce((acc, fieldStr) => {
    const parts = fieldStr.split(KVP_SEPARATOR)
    const field = parts[0]
    const hasOperation = parts.length === 3
    const operation = hasOperation ? parts[1] : undefined
    const values = parts[hasOperation ? 2 : 1].split(VALUES_SEPARATOR).map(decodeURIComponent)

    acc[field] = {
      values,
      ...(hasOperation && { operation }),
    }

    return acc
  }, {})
}
